import { useEffect } from 'react';
import seo from '../data/seo.json';

const setMeta = (attr, key, content) => {
  let tag = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!tag) {
    tag = document.createElement('meta');
    tag.setAttribute(attr, key);
    document.head.appendChild(tag);
  }
  tag.setAttribute('content', content);
};

const setCanonical = (href) => {
  let link = document.head.querySelector('link[rel="canonical"]');
  if (!link) {
    link = document.createElement('link');
    link.setAttribute('rel', 'canonical');
    document.head.appendChild(link);
  }
  link.setAttribute('href', href);
};

// Keeps the title, description, canonical and social tags in sync with the
// current page. scripts/postbuild.js writes the same values into each route's
// static HTML so crawlers that don't run JavaScript see them too.
// Pass null for pages that shouldn't be indexed (the 404 page).
const useSeo = (path) => {
  useEffect(() => {
    const page = path && seo.pages[path];
    const meta = page || seo.notFound;
    const url = `${seo.siteUrl}${path || ''}`;

    document.title = meta.title;
    setMeta('name', 'description', meta.description);
    setMeta('property', 'og:title', meta.title);
    setMeta('property', 'og:description', meta.description);
    setMeta('property', 'og:url', url);
    setMeta('name', 'twitter:title', meta.title);
    setMeta('name', 'twitter:description', meta.description);
    setMeta('name', 'robots', page ? 'index, follow' : 'noindex');
    setCanonical(url);
  }, [path]);
};

export default useSeo;
